import React from 'react';
// import Cookies from 'js-cookie';
import { connect } from 'react-redux';
import {
    initHandler,
    ajaxViewHandler,
    ajaxHandler,
    setConfig,
} from "../../store/actions";
import {
    // Breadcrumb,
    // Card,
    Row,
    Col,
    // Input,
    // Button,
    // Table,
    // Modal,
    message,
    // Alert,
    // Select,
    // Tooltip,
    // Spin,
    // Form,
    // Skeleton
} from 'antd';

// import moment from 'moment';

import Config from '../../Config';
import { Helmet } from "react-helmet";
import queryString from 'query-string';

import '../../assets/laporan.css';


const configClass = {
    title: 'LAPORAN TELLER',
    apiUrl: {
        preview: 'laporan/api/teller/',
        userProfile: "auth/api/user/info"
    },

}

class LapTellerCetak extends React.Component {
    config;

    constructor(props) {
        super(props);
        this.config = new Config();
        this.state = {
            loading: false,
            data: null,
            err: false,

            namauptppd: 'SAMSAT PALANGKARAYA',

            mulai_dari: "",
            sampai_dengan: "",
        }

        // this.preview(this.props.match.params.id);

    }

    componentDidMount() {
        var uri_params = "";
        const uri_string = queryString.parse(this.props.location.search);

        for (var key in uri_string) {
            if (uri_params == "") {
                uri_params = "?" + key + "=" + uri_string[key];
            } else {
                uri_params += "&" + key + "=" + uri_string[key];
            }
            if (key == "mulai_dari") {
                this.setState({
                    mulai_dari: uri_string[key]
                })
            } else if (key == "sampai_dengan") {
                this.setState({
                    sampai_dengan: uri_string[key]
                })
            }
        }
        this.preview(uri_params);
    }

    async preview(uri_params) {
        message.loading({ content: 'Menampilkan laporan...', duration: 0, key: 'toast' });
        this.setState({
            loading: true,
            err: false,
            data: null,
        });

        this.props.ajaxViewHandler('get', configClass.apiUrl.preview + uri_params)
            .then(() => {
                const data = this.props.responseMsg;
                if (this.props.isSuccess) {
                    message.destroy();
                    this.setState({
                        loading: false,
                        data: data,
                        err: false
                    });
                    setTimeout(function () {
                        window.print();

                    }, 1300);
                } else {
                    const errTitle = 'error get laporan';
                    this.setState({
                        loading: false,
                        data: null,
                        err: true,
                        errMsg: this.props.responseMsg
                    });
                    message.error({ content: errTitle, duration: 2, key: 'toast' });
                }
            }).catch((response) => {
                this.setState({
                    loading: false,
                    data: null,
                    err: true,
                    errMsg: 'unknown response'
                });
                console.log('gagal_get_laporan', response);
                message.error({ content: 'gagal request data, coba lagi', duration: 2, key: 'toast' });
            });
    }

    render() {
        return (
            <>
                <Helmet>
                    <title>{configClass.title}</title>
                </Helmet>
                {(this.state.data != null && this.state.data?.data?.[0].status == 1 && 
                    <div className="kertas-laporan" style={{width: '100%'}}>
                        <div style={{ textAlign:'center', marginBottom:14 }}>
                            <div style={{ fontSize:15, fontWeight:'bold', textTransform:'uppercase' }}>Laporan Penerimaan Harian Teller</div>
                            <div style={{ fontSize:13, fontWeight:'bold' }}>SAMSAT {this.state.data?.upt?.toUpperCase()}</div>
                        </div>
                        <Row style={{ paddingBottom: 2, fontWeight: 'bold' }}>
                            <Col span={4} className="titik-dua">SAMSAT</Col>
                            <Col span={8}>{this.state.data?.upt.toUpperCase()}</Col>
                        </Row>
                        <Row style={{ paddingBottom: 2, fontWeight: 'bold' }}>
                            <Col span={4} className="titik-dua">TANGGAL</Col>
                            <Col span={8}>{this.state.data?.tanggal.toUpperCase()}</Col>
                        </Row>
                        <Row style={{ paddingBottom: 10, fontWeight: 'bold' }}>
                            <Col span={4} className="titik-dua">OPERATOR</Col>
                            <Col span={8}>{this.state.data?.operator.toUpperCase()}</Col>
                        </Row>
                        <table className="laporan-cetak" cellPadding="2" border="1" style={{ tableLayout: 'fixed', width: '100%' }}>
                            <thead style={{border: 'none'}}>
                                <tr style={{borderTop: '1px solid #000000', borderBottom: '1px solid #000000'}}>
                                    <th style={{width: '50px'}} rowSpan={2}> NO</th>
                                    <th style={{width: '100px'}} rowSpan={2}> NO. POLISI</th>
                                    <th style={{width: '250px', textAlign: 'left'}} rowSpan={2}> NAMA PEMILIK</th>
                                    <th style={{width: '120px'}} rowSpan={2}> NO. NOTICE</th>
									<th colSpan={2} style={{textAlign:'center'}}>PROVINSI</th>
									<th colSpan={2} style={{textAlign:'center'}}>KABUPATEN/KOTA</th>
									<th style={{width: '120px', textAlign:'right'}} rowSpan={2}>SWDKLLJ</th>
									<th style={{width: '120px', textAlign:'right'}} rowSpan={2}>PNBP</th>
									<th style={{width: '120px', textAlign:'right'}} rowSpan={2}>SP3</th>
									<th style={{width: '120px', textAlign:'right'}} rowSpan={2}>JUMLAH TOTAL</th>
                                    <th style={{width: '120px'}} rowSpan={2}> KETERANGAN</th>
                                </tr>
                                <tr style={{borderTop: '1px solid #000000', borderBottom: '1px solid #000000'}}>
                                    <th style={{width: '120px', textAlign:'right'}}>BBNKB</th>
                                    <th style={{width: '120px', textAlign:'right'}}>PKB</th>
                                    <th style={{width: '120px', textAlign:'right'}}>OPSEN BBNKB</th>
                                    <th style={{width: '120px', textAlign:'right'}}>OPSEN PKB</th>
                                </tr>
                            </thead>
                            <tbody style={{border: 'none'}}>
                                {this.state.data.data.map((item, idx) => {
                                    const fp = (val) => {
                                        const n = parseInt(String(val || '0').replace(/[^0-9]/g, ''), 10);
                                        return n === 0 ? '—' : val;
                                    };
                                    return (
                                    <tr key={idx} style={{borderTop: 'none', borderBottom: '1px solid #000000'}}>
                                        <td style={{ textAlign: 'center' }}>{idx+1}</td>
                                        <td style={{ textAlign: 'center' }}>{item.nomor_polisi}</td>
                                        <td style={{ textAlign: 'left' }}>{item.nama_pemilik}</td>
                                        <td style={{ textAlign: 'center' }}>{item.nomor_notice}</td>
                                        <td style={{ textAlign: 'right' }}>{fp(item.jumlah_bbnkb)}</td>
                                        <td style={{ textAlign: 'right' }}>{fp(item.jumlah_pkb)}</td>
                                        <td style={{ textAlign: 'right' }}>{fp(item.jumlah_opsen_bbnkb)}</td>
                                        <td style={{ textAlign: 'right' }}>{fp(item.jumlah_opsen_pkb)}</td>
                                        <td style={{ textAlign: 'right' }}>{fp(item.jumlah_swdkllj)}</td>
                                        <td style={{ textAlign: 'right' }}>{fp(item.jumlah_pnbp)}</td>
                                        <td style={{ textAlign: 'right' }}>{fp(item.jumlah_sp3)}</td>
                                        <td style={{ textAlign:'right' }}>{item.jumlah_total}</td>
                                        <td style={{ textAlign: 'center' }}>{item.keterangan || '—'}</td>
                                    </tr>
                                    );
                                })}
                            </tbody>
                            {(this.state.data != null &&
								<tfoot>
								</tfoot>
							)}
                        </table>
                        <table style={{ tableLayout: 'fixed', width: '100%' }}>
                            <tr style={{ borderTop: '3px double #000000', borderBottom: '1px solid #000000' }}>
                                <td colspan={4} style={{width: '520px', textAlign: 'center', fontWeight: 'bold' }}>JUMLAH TOTAL</td>
                                <td style={{width: '120px', textAlign: 'right', fontWeight: 'bold' }}>{this.state.data.total_penerimaan_bbnkb}</td>
                                <td style={{width: '120px', textAlign: 'right', fontWeight: 'bold' }}>{this.state.data.total_penerimaan_pkb}</td>
                                <td style={{width: '120px', textAlign: 'right', fontWeight: 'bold' }}>{this.state.data.total_penerimaan_opsen_bbnkb}</td>
                                <td style={{width: '120px', textAlign: 'right', fontWeight: 'bold' }}>{this.state.data.total_penerimaan_opsen_pkb}</td>
                                <td style={{width: '120px', textAlign: 'right', fontWeight: 'bold' }}>{this.state.data.total_penerimaan_swdkllj}</td>
                                <td style={{width: '120px', textAlign: 'right', fontWeight: 'bold' }}>{this.state.data.total_penerimaan_pnbp}</td>
                                <td style={{width: '120px', textAlign: 'right', fontWeight: 'bold' }}>{this.state.data.total_penerimaan_sp3}</td>
                                <td style={{width: '120px', textAlign: 'right', fontWeight: 'bold' }}>{this.state.data.total_penerimaan_all}</td>
                                <td style={{width: '120px'}} ></td>
                            </tr>
                        </table>
                    </div>
                )}
            </>
        )
    }

}

const mapStateToProps = function (state) {
    return state.configReducers
}

export default connect(
    mapStateToProps,
    {
        initHandler,
        setConfig,
        ajaxViewHandler,
        ajaxHandler,
    }
)(LapTellerCetak);